import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSsoConfig,
  deleteSsoConfig,
  getSsoConfig,
  updateSsoConfig,
} from "controller/api";
import { ApiErrorType, CreateSsoInput, UpdateSsoInput } from "shared";
import { sentryLogger } from "utilz";
import { debugConsole } from "utilz/helpers";

export const useGetCustomerSsoDetails = (customerId: string) => {
  return useQuery({
    queryKey: ["sso", customerId],
    queryFn: () => getSsoConfig(customerId),
    enabled: customerId ? true : false,
    onError: (err) => debugConsole(err),
  });
};

export const useCreateSsoConfig = () => {
  const queryClient = useQueryClient();
  return useMutation((value: CreateSsoInput) => createSsoConfig(value), {
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries(["sso", variables.customer_id]);
    },
  });
};

export const useUpdateSsoConfig = () => {
  const queryClient = useQueryClient();
  return useMutation((value: UpdateSsoInput) => updateSsoConfig(value), {
    onSuccess(data, variables, context) {
      queryClient.invalidateQueries(["sso", variables.customer_id]);
    },
    onError: (error: ApiErrorType) => {
      sentryLogger({
        error: error,
        workflow: "customer",
        functionName: "updateSsoConfig",
      });
    },
  });
};

export const useDeleteSsoConfig = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (ssoConnectorId: string) => deleteSsoConfig(ssoConnectorId),
    {
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(["sso"]);
      },
    }
  );
};
